// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","wrapper":"_1U5mDF3TToNSpMP99NvYkP","leftColumn":"_3zIcfrFzCwEOgltTw2oFgq","rightColumn":"_259R_qXc0XY98WB174NQWk","menu":"_1r2LJbTpJ1qCAeM9YSs8Xi","preloader":"ew9_bBv6vvcrWPhg_R0UD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Resources/Resources.mod.css
// module id = 1642
// module chunks = 0